<div class="dropdown {{showDdl ? 'open' : ''}}">
  <div class="inner-addon left-addon">
    <i class="glyphicon armx-search"></i>
    <input type="text" #searchInput class="form-control" placeholder="search" (input)="search($event)" [(ngModel)]="searchTerm"  />
  </div>
  <ul class="dropdown-menu">
    <li *ngFor="let item of tempContent; index as i"
        (click)="change(item)"
        class="{{i==arrowkeyLocation? 'active' :''}}"><a>{{item.DisplayName}}</a></li>
  </ul>
</div>


